<app-grid
  gridCssClass="tab-grid"
  stateKey="CustomerCreditSalesOrders"
  [columnDefs]="columnDefs"
  [header]="header"
  [rowData]="model$ | async"
  [showDelete]="false"
></app-grid>
